export const environment = {
  production: false,
  apiUrl: 'https://nomoros-dev-api.crio-server.com/api',
  locale: 'en',
  fallbackLocale: 'en',
};
